import { compareData } from '@/mocks/gossipData';
import { SectionHead } from './common';

const outcomeTone: Record<string, string> = {
  实锤: 'bg-primary-100 text-primary-800 border-primary-200',
  辟谣: 'bg-secondary-100 text-secondary-900 border-secondary-200',
  待核实: 'bg-accent-100 text-accent-900 border-accent-200',
};

const outcomeIcon: Record<string, string> = {
  实锤: 'ri-checkbox-circle-fill',
  辟谣: 'ri-close-circle-fill',
  待核实: 'ri-hourglass-fill',
};

export default function CompareSection() {
  return (
    <section id="compare" className="w-full scroll-mt-24 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <SectionHead
          eyebrow="辟谣实锤对照"
          title="一句话说法 ⇄ 查证结论"
          desc="把网传原文与查证后的结论并排摆出来，谁在混淆视听、谁有实据支撑，对照一次看清。收录样本按可信度标注：实锤、辟谣与待核实。"
        />

        <div className="mt-7 flex flex-col gap-3">
          {compareData.map((row) => (
            <div
              key={row.id}
              className="grid grid-cols-1 overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-background-300 md:grid-cols-[1fr_auto_1fr]"
            >
              <div className="flex items-start gap-3 p-4 md:p-5">
                <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-chat-quote-line text-base" />
                </span>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 text-xs font-semibold text-foreground-400">
                    <span className="uppercase">网传说法</span>
                    <span className="inline-flex items-center gap-1"><i className="ri-shield-user-line" /> {row.source}</span>
                  </div>
                  <p className="mt-1.5 text-sm font-semibold leading-snug text-foreground-900">{row.rumor}</p>
                </div>
              </div>

              <div className="flex items-center justify-start gap-2 border-y border-background-200 bg-background-100/70 px-4 py-2 md:w-auto md:justify-center md:border-y-0 md:border-x md:px-5 md:py-0">
                <i className="ri-arrow-down-line text-background-400 md:hidden" />
                <i className="ri-arrow-right-line text-background-400 hidden md:inline" />
              </div>

              <div className="flex items-start gap-3 p-4 md:p-5">
                <span className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${row.type === '实锤' ? 'bg-primary-100 text-primary-700' : row.type === '辟谣' ? 'bg-secondary-100 text-secondary-700' : 'bg-accent-100 text-accent-700'}`}>
                  <i className={outcomeIcon[row.type]} />
                </span>
                <div className="min-w-0">
                  <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-semibold ${outcomeTone[row.type]}`}>
                    {row.type}
                  </span>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{row.fact}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}